import './FieldText.css';

import React from 'react';
import { generateClassName, truncateText } from './helpers';
import { useNavigate } from 'react-router-dom';

const FieldText = ({ label = null, text = null, textLink = null, className = null,
    labelAlign = 'center', textAlign = 'center', textWordsLimit = null, textLinesLimit = null, minLines = null, lineHeight = 1.2, scrollable = false, heightInLines = 5, CRsDetection = false }) => {

    const navigate = useNavigate();

    const handleClickOnText = () => {
        if (textLink) {
            navigate(textLink);
        }
    }

    const minHeight = minLines ? `${minLines * lineHeight}em` : 'auto';
    const maxHeight = heightInLines ? `${heightInLines * lineHeight}em` : 'auto';

    return (
        <div className={generateClassName('field-text', '', className)}>
            {label && (
                <div className={`${generateClassName('field-text', '-label', className)} label-align-${labelAlign}`}>
                    {label}
                </div>
            )}
            {text && (
                <div className={`${generateClassName('field-text', '-text', className)} text-align-${textAlign} ${textLink ? 'text-has-link' : ''} ${textLinesLimit ? 'line-clamp' : ''} ${minLines ? 'min-lines' : ''} ${scrollable ? 'scrollable' : ''}`}
                    style={{
                        WebkitLineClamp: textLinesLimit,
                        display: textLinesLimit ? '-webkit-box' : 'flex',
                        WebkitBoxOrient: textLinesLimit ? 'vertical' : 'initial',
                        overflow: scrollable ? 'auto' : (textLinesLimit ? 'hidden' : 'initial'),
                        textOverflow: textLinesLimit ? 'ellipsis' : 'initial',
                        minHeight: minHeight,
                        maxHeight: scrollable ? maxHeight : 'none',
                        lineHeight: lineHeight
                    }}
                    onClick={handleClickOnText}
                    dangerouslySetInnerHTML={{ __html: truncateText(text, textWordsLimit, CRsDetection) }}
                />
            )}
        </div>
    );
};

export default FieldText;